import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=71ab65be&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=ts"
export * from "./TitlePage.vue?vue&type=script&lang=ts"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=71ab65be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab65be",
  null
  
)

export default component.exports